export function generateCronExpression(formState: any): string | null {
  if (formState.mode === 'once') return null;
  if (formState.mode === 'cron') return formState.cronExpr;

  const { unit, every = 1, selectedWeekDays = [] } = formState;
  const t = new Date(formState.startDateTime ?? Date.now());
  const hour = t.getHours();
  const minute = t.getMinutes();

  switch (unit) {
    case 'Minute':
      return `*/${every} * * * *`;

    case 'Hour':
      return `0 */${every} * * *`;

    case 'Day':
      return `${minute} ${hour} */${every} * *`;

    case 'Week': {
      if (!selectedWeekDays.length) return `${minute} ${hour} * * 0`;
      const dayMap: Record<string, string> = {
        Sun: '0', Mon: '1', Tue: '2', Wed: '3', Thu: '4', Fri: '5', Sat: '6'
      };
      const days = (selectedWeekDays as string[])
        .map(d => dayMap[d])
        .filter(Boolean)
        .sort()
        .join(',');
      return `${minute} ${hour} * * ${days}`;
    }

    case 'Month': {
      const dom = normalizeList(formState.monthDay) || '1';
      return `${minute} ${hour} ${dom} */${every} *`;
    }

    case 'Custom': {
      // Use derived selections from the calendar (monthDay + customMonths)
      const dom = normalizeList(formState.monthDay) || '1';
      const mon = normalizeList(formState.customMonths) || '*';
      return `${minute} ${hour} ${dom} ${mon} *`;
    }

    default:
      return formState.cronExpr || '0 0 * * *';
  }
}

function normalizeList(val: unknown): string {
  if (Array.isArray(val)) return val.filter(isFiniteNumber).join(',');
  if (typeof val === 'number') return String(val);
  if (typeof val === 'string') return val.trim();
  return '';
}
function isFiniteNumber(n: unknown): n is number {
  return typeof n === 'number' && Number.isFinite(n);
}
